export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de reportes"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de calidad"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicar filtros"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])},
          "not_records_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se encontraron registros de inspecciones de calidad"])},
          "number_rows_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Inspecciones de calidad"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspections"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])},
          "not_records_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No records found"])},
          "number_rows_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Quality inspections"])}
        }
      }
    }
  })
}